module.exports = __webpack_public_path__ + "static/img/20240426_2.9538b70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2024/20240426_2.png
// module id = uRwr
// module chunks = 0